import { Cookies } from "typescript-cookie";
import { ENVTokenName } from "../env";
export const saveTokenAsCookie = (token: any) => {
  try {
    const tokendata =
      typeof token === "string"
        ? JSON.parse(token)
        : JSON.parse(JSON.stringify(token));
    const expiryDate = new Date();
    expiryDate.setMonth(expiryDate.getMonth() + 1);

    if (
      tokendata?.user?.wishlist &&
      tokendata?.user?.wishlist_color_reference
    ) {
      delete tokendata.user.wishlist;
      delete tokendata.user.wishlist_color_reference;
      Cookies.set(ENVTokenName, JSON.stringify(tokendata), {
        expires: expiryDate,
      });
    } else if (tokendata?.user) {
      Cookies.set(ENVTokenName, JSON.stringify(tokendata), {
        expires: expiryDate,
      });
    }
  } catch (error) {
    console.log("🚀 ~ saveTokenAsCookie ~ error:", error);
  }
};
